if(typeof BSS_B2B != undefined) {
  setTimeout(() =>{
    const targetCart = document.querySelector("#mini-cart");
    if (targetCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
        for (const record of recordList) {
          if (record.target.classList.contains("mini-cart")) {
              setTimeout(() =>{
                BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
                BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
              }, 300)
            
          }
        }
       
      });
      mutationObserver.observe(targetCart, { childList: true, subtree: true, attributes: true });
    }
  }, 500)
}